import { apiClient } from "../common/axiosInstance";
import { IFormData, IUserResponse } from "./types";
import { handleAxiosError } from "../common/handleAxiosError";

export const createUser = async (formData: IFormData) => {
  try {
    const { data }: { data: IUserResponse } = await apiClient.post("/users/create", formData)
    return data;
  } catch (error) {
    handleAxiosError(error, "Error al crear el usuario");
  }
};
